import {Component} from '@angular/core';
import { UUID } from 'angular2-uuid';

import {SterbefallIO} from '../../model/sterbefall.io';
import {Anrede, SterbefallStatus} from '../../model/enums';
import {Verstorbener} from '../../model/verstorbener';

import {GuiProvider} from '../../providers/gui.provider';
import {SterbefallProvider} from '../../providers/sterbefall.provider';
import {ServerProvider} from "../../providers/server.provider";


@Component({
  templateUrl: 'demo.html'
})
export class DemoPage {

	customServerUrl : string;

  constructor(private sterbefallProvider: SterbefallProvider,
              private guiProvider: GuiProvider,
              private serverProvider: ServerProvider) {
  }

	ionViewWillEnter() {
		this.customServerUrl = this.serverProvider.serverUrl;
	}

  createData() {
    let io = new SterbefallIO();
    let s = this.sterbefallProvider.sterbefaelle[0];
    for (let i = 0; i < 100; i++) {
      let o = io.saveSterbefall(s);
      s = io.loadSterbefall(o);
      s.id = UUID.UUID();
      s.status = Math.random() < 0.7 ? SterbefallStatus.Entwurf : SterbefallStatus.Gesendet;
      this.setRandomData(s.verstorbener);
      this.sterbefallProvider.sterbefaelle.unshift(s);
    }
    this.sterbefallProvider.savePermanent();
    this.guiProvider.showAlert("Demo", "Anzahl der Sterbefälle: " + this.sterbefallProvider.sterbefaelle.length);
  }

  resetData() {
    let s = new SterbefallIO().loadSterbefall(
      {"personen":[{"anrede":"2","nachname":"Brandstätter","vorname":"Theobald","familienstand":"1","beruf":"Betriebsschlosser","religion":"r.k.","staatsangehoerigkeit":"deutsch","krankenkasse":"Eisenstadt BKK","plz":"85051","ort":"Ingolstadt","strasse":"Bahnhofstr. 1","vormund":"","geburtsdatum":"05.08.1949","geburtseintrag":"3232/1949","geburtsort":"München","sterbedatum":"27.09.2016","sterbezeit":"14:00","todesursache":"1","sterbeplatz":"Seniorenheim St. Hildegard","sterbeplz":"86529","sterbeort":"Schrobenhausen","sterbestandesamt":"Schrobenhausen","class":"Verstorbener"},{"verwandtschaft":10,"anrede":"1","nachname":"Brandstätter","geburtsname":"","vorname":"Edeltraud","plz":"85051","ort":"Ingolstadt","strasse":"Bahnhofstr. 1","ehedatum":"01.09.1979","eheort":"Ingolstadt","standesamt":"Ingolstadt","eheregisternr":"35/79","telefon1":"08000 46181","class":"Person"},{"verwandtschaft":8,"anrede":2,"class":"Person"},{"verwandtschaft":9,"anrede":1,"class":"Person"},{"verwandtschaft":"1","anrede":"1","nachname":"Birkmeier","vorname":"Johanna","plz":"86554","ort":"Pöttmes","strasse":"Hochschulweg 4","geburtsdatum":"03.04.1980","zahltfriedhof":true,"email":"johanna@birkmeier-erdarbeiten.de","telefon1":"08000 906080","fax":"08000 906083","class":"Person"},{"verwandtschaft":"1","anrede":"1","nachname":"Birkmeier","vorname":"Linda","geburtsdatum":"","bemerkung":"nach unbekannt verzogen","class":"Person"}],"schema":"0.2","status":1,"verstorbener":{"personIndex":0},"ehepartner":{"personIndex":1},"vater":{"personIndex":2},"mutter":{"personIndex":3},"verwandte":[{"personIndex":4},{"personIndex":5}],"anmelder":{"personIndex":1},"grabrecht":{"personIndex":4},"kostentraeger":{"personIndex":4},"bestattung":{"trauerfeier":{},"bestattung":{"datum":"05.10.2016","uhrzeit":"14:00","beschreibung":"Pfarrer Reinhardt"},"art":"1","ort":"Ingolstadt","friedhof":"Westfriedhof","grablage":"A 56","bemerkung":"Blaue Blumen am Grab","musik":"Bläserensemble"},"termine":[{"datum":"09.10.2016","uhrzeit":"15:00","beschreibung":"Rückruf wegen Rechnungsstellung"},{"datum":"08.10.2016","uhrzeit":"16:00","beschreibung":"Rücksprache mit Notar"}],"id":"f6bd589a-21a7-eca1-da23-0e4747966a8f","sterbebuch":true,"auskunftssperre":false,"zeitung":true,"verfuegungArt":"2","verfuegungdaten":"Notar Schmitz"});
    this.sterbefallProvider.sterbefaelle = [s];
  }

  setRandomData(v: Verstorbener) {
    v.nachname = this.nachnamen[Math.floor(Math.random()*this.nachnamen.length)];
    v.anrede = (Math.random() < 0.5 ? Anrede.Herr : Anrede.Frau)
    let vornamen = (v.anrede == Anrede.Herr ? this.vornamenM : this.vornamenW);
    v.vorname = vornamen[Math.floor(Math.random()*vornamen.length)];
    v.geburtsdatum = Math.floor(Math.random()*28+1) + "." + Math.floor(Math.random()*12+1) + "." + Math.floor(Math.random()*50+1940);
    v.sterbedatum = Math.floor(Math.random()*28+1) + "." + Math.floor(Math.random()*10+1) + ".2016";
  }

  nachnamen = ["Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz",
    "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann"];
  vornamenW = ["Ursula", "Karin", "Helga", "Sabine", "Ingrid", "Renate", "Monika", "Susanne", "Gisela", "Petra"];
  vornamenM = ["Peter", "Michael", "Thomas", "Andreas", "Wolfgang", "Klaus", "Jürgen", "Günther", "Stephan", "Christian"];

	saveServer() {
    this.serverProvider.serverUrl = this.customServerUrl;
	}

}



// WEBPACK FOOTER //
// ./src/pages/demo/demo.ts